export const SecurityWebComponentKey = 'security-web-component-7i90u' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
